__turbopack_context__.v({
  "buttonsWrapper": "image-buttons-module-scss-module__0Iy8yW__buttonsWrapper",
  "container": "image-buttons-module-scss-module__0Iy8yW__container",
  "expandImageIcon": "image-buttons-module-scss-module__0Iy8yW__expandImageIcon",
  "oaWrapper": "image-buttons-module-scss-module__0Iy8yW__oaWrapper",
});
